import React, { useState } from "react";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { SearchInitialData } from "../types/interface";
import {
  getDefaultNotificationPerodic,
  getSearchParams,
} from "../utils/search";

const initialData: SearchInitialData = {
  name: "",
  notificationPeriodic: getDefaultNotificationPerodic(),
  filters: {},
  conversations: [],
  conversationsCount: 0,
  cxTopics: [],
  updateName: (name) => {},
  updateNotificationPeriodic: (periodic) => {},
  updateFilters: (filters) => {},
  updateConversations: (conversations) => {},
  updateConversationsCount: (count) => {},
  updateCXTopics: (topics) => {},
  setDefault: () => {},
};

export const SearchContext = React.createContext(initialData);

const SearchContextProvider = (props: any) => {
  // Get search params and set to filters
  const [searchParams] = useSearchParams();
  const searchFilters = getSearchParams(searchParams);

  let navigate = useNavigate();

  const [name, setName] = useState(initialData.name);
  const [notificationPeriodic, setNotificationPeriodic] = useState(
    initialData.notificationPeriodic
  );
  const [filters, setFilters] = useState(
    searchFilters ? searchFilters : initialData.filters
  );
  const [conversations, setConversations] = useState(initialData.conversations);
  const [cxTopics, setCXTopics] = useState(initialData.cxTopics);
  const [conversationsCount, setConversationsCount] = useState(
    initialData.conversationsCount
  );

  const updateNameHandler = (name: string = initialData.name) => {
    setName(name);
  };

  const updateNotificationPeriodicHandler = (
    periodic: string = initialData.notificationPeriodic
  ) => {
    setNotificationPeriodic(periodic);
  };

  const updateFiltersHandler = (filters: any = initialData.filters) => {
    // Creating search params on selecting any filters
    let params: any = {};
    Object.keys(filters).map((filter: any) => {
      params[filter] = Array.isArray(filters[filter])
        ? filters[filter].join()
        : filters[filter];
    });
    navigate({
      search: createSearchParams(params).toString(),
    });

    setFilters(filters);
  };

  const updateConversationsHander = (
    conversations: [] = initialData.conversations
  ) => {
    setConversations(conversations);
  };

  const updateConversationsCountHandler = (
    count: number = initialData.conversationsCount
  ) => {
    setConversationsCount(count);
  };

  const updateCXTopicsHandlers = (topics: [] = initialData.cxTopics) => {
    setCXTopics(topics);
  };

  const setDefaultHandler = () => {
    updateNameHandler();
    updateFiltersHandler();
    updateNotificationPeriodicHandler();
    updateConversationsHander();
    updateCXTopicsHandlers();
  };

  const contextValue = {
    name: name,
    notificationPeriodic: notificationPeriodic,
    filters: filters,
    conversations: conversations,
    conversationsCount: conversationsCount,
    cxTopics: cxTopics,
    updateName: updateNameHandler,
    updateFilters: updateFiltersHandler,
    updateNotificationPeriodic: updateNotificationPeriodicHandler,
    updateConversations: updateConversationsHander,
    updateConversationsCount: updateConversationsCountHandler,
    updateCXTopics: updateCXTopicsHandlers,
    setDefault: setDefaultHandler,
  };

  return (
    <SearchContext.Provider value={contextValue}>
      {props.children}
    </SearchContext.Provider>
  );
};

export default SearchContextProvider;
